module.exports = __webpack_public_path__ + "static/media/fomento1.76f66dae.jpg";